var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9607"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 25186"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffc62d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.19 7.708h1.783v1.783H7.19z",
    "data-name": "Rectangle 3055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.986 7.708h1.783v1.783H9.986z",
    "data-name": "Rectangle 3056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.397 10.419H6.18v1.783H4.397z",
    "data-name": "Rectangle 3057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19 10.419h1.783v1.783H7.19z",
    "data-name": "Rectangle 3058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.986 10.419h1.783v1.783H9.986z",
    "data-name": "Rectangle 3059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.334 4.394a.8.8 0 0 1-.8-.8V1.8a.8.8 0 0 1 .8-.8.8.8 0 0 1 .8.8v1.8a.8.8 0 0 1-.8.794",
    "data-name": "Path 3824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.875 2.696h-.906v1.089a1.214 1.214 0 0 1-1.2 1.221h-.32a1.214 1.214 0 0 1-1.2-1.221V2.696h-2.48v1.089a1.214 1.214 0 0 1-1.2 1.221h-.318a1.214 1.214 0 0 1-1.2-1.221V2.696h-.694a1.367 1.367 0 0 0-1.358 1.372v9.6a1.367 1.367 0 0 0 1.353 1.372h9.526a1.367 1.367 0 0 0 1.353-1.372v-9.6a1.37 1.37 0 0 0-1.356-1.372m-.23 9.679a.85.85 0 0 1-.84.853h-7.38a.85.85 0 0 1-.84-.853V7.536a.88.88 0 0 1 .84-.886h7.38a.88.88 0 0 1 .84.886Z",
    "data-name": "Path 3825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.615 4.394a.8.8 0 0 1-.8-.8V1.8a.8.8 0 0 1 .8-.8.8.8 0 0 1 .8.8v1.8a.8.8 0 0 1-.8.794",
    "data-name": "Path 3826"
  })))));
};
export { SvgCalendar as ReactComponent };
export default "/_next/static/images/calendar.svg";